import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StorageIcon from "@mui/icons-material/Storage";
import { DataGrid } from "@mui/x-data-grid";

import { DatabaseFindings } from "./unused-sql-objects-service";
import { getUnusedObjectsColumns } from "./unused-sql-objects-columns";

interface DatabaseAccordionProps {
  database: DatabaseFindings;
  expanded: boolean;
  onToggle: (expanded: boolean) => void;
}

const DatabaseAccordion: React.FC<DatabaseAccordionProps> = ({
  database,
  expanded,
  onToggle,
}) => {
  const columns = getUnusedObjectsColumns();

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => onToggle(isExpanded)}
      sx={{
        mb: 2,
        "&:before": { display: "none" },
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        borderRadius: "8px !important",
        overflow: "hidden",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          bgcolor: "grey.50",
          "&:hover": { bgcolor: "grey.100" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <StorageIcon color="primary" />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {database.databaseName}
          </Typography>
          <Chip
            label={`${database.findingCount} object${database.findingCount !== 1 ? "s" : ""}`}
            color="warning"
            size="small"
            sx={{ ml: "auto", mr: 2, fontWeight: 600 }}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Box sx={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={database.findings.map((finding, idx) => ({
              id: `${database.databaseName}-${idx}`,
              ...finding,
            }))}
            columns={columns}
            pageSizeOptions={[10, 25, 50, 100]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            disableRowSelectionOnClick
            getRowHeight={() => "auto"}
            sx={{
              border: "none",
              "& .MuiDataGrid-cell": {
                borderColor: "grey.200",
                py: 1,
              },
              "& .MuiDataGrid-columnHeaders": {
                bgcolor: "grey.50",
                borderColor: "grey.200",
              },
            }}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default DatabaseAccordion;
